var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("board-changelog-item", {
        directives: [
          {
            name: "b-toggle",
            rawName: "v-b-toggle",
            value: "changelog-collapse-" + _vm.changelog.id,
            expression: "`changelog-collapse-${changelog.id}`",
          },
        ],
        class: {
          "column-divider-bottom": !_vm.isLast,
          "clickable changelog-details-tooltip": !!_vm.changelogComponent(
            _vm.changelog.type
          ),
          "cursor-initial": !_vm.changelogComponent(_vm.changelog.type),
        },
        attrs: {
          "user-details": _vm.userDetails,
          changelog: _vm.changelog,
          "board-id": _vm.boardId,
          origin: _vm.origin,
        },
      }),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { id: "changelog-collapse-" + _vm.changelog.id } },
        [
          _c(
            "div",
            { staticClass: "changelog-popover" },
            [
              _c(_vm.changelogComponent(_vm.changelog.type), {
                tag: "component",
                attrs: {
                  value: _vm.changelog.value,
                  operation: _vm.changelog.operation,
                  field: _vm.changelog.field,
                  type: _vm.changelog.type,
                  "insertion-timestamp": _vm.changelog.insertionTimestamp,
                  "user-details": _vm.changelog.userDetails,
                  "small-text": false,
                  "show-value-on-new-line": "",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }